// Apply discount on cart
//
// @param {string} data-section-id
//
// @example
// <w3-cart-discount data-section-id="{{ section_id }}">
//     ...
// </w3-cart-discount>

class CartDiscount extends HTMLElement {
    constructor() {
        super();

        this.applyDiscount = this.applyDiscount.bind(this);
        this.removeDiscount = this.removeDiscount.bind(this);
    }

    connectedCallback() {
        // Attributs
        this.type = this.getAttribute('data-type') || null;

        // Elements
        this.errorDiscountCode = this.querySelector('#cart-discount-error-discount-code');
        this.errorShipping = this.querySelector('#cart-discount-error-shipping');

        // Events
        this.addEventListener('submit', this.applyDiscount);
        this.addEventListener('click', this.removeDiscount);
    }

    // Apply discount code
    async applyDiscount(event) {
        event.preventDefault();
        event.stopPropagation();

        // Hide error
        this.errorDiscountCode.classList.add('hidden');
        this.errorShipping.classList.add('hidden');

        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const input = form.querySelector('input[name="discount"]');
        if (!(input instanceof HTMLInputElement)) return;

        const discount = input.value.trim();
        if (!discount) return;

        const checkExistingCodes = this.#existingDiscounts();

        // Don't add two times the same code
        if (!checkExistingCodes.includes(discount)) {
            checkExistingCodes.push(discount);
        }

        console.log(checkExistingCodes.join(','));

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: checkExistingCodes.join(','), sections: [this.dataset.sectionId] }),
        });

        const data = await response.json();

        console.log(data);

        const result = data.discount_codes.find((d) => d.code === discount);

        // For error on code discount
        if (!result || result.applicable === false) {
            this.#handleDiscountError('discount_code');
            input.value = '';
            return;
        }

        // For error on shipping discount
        const newHtml = data.sections[this.dataset.sectionId];
        const doc = new DOMParser().parseFromString(newHtml, 'text/html');
        const pills = doc.querySelectorAll('.cart-discount-pill');

        console.log('doc', doc);
        console.log('pills', pills);

        const newCodes = Array.from(pills)
            .map((el) => el.dataset.discountCode)
            .filter(Boolean);

        const existingCodes = this.#existingDiscounts();

        const noNewPillAdded =
            newCodes.length === existingCodes.length && newCodes.every((code) => existingCodes.includes(code));

        if (noNewPillAdded) {
            input.value = '';
            this.#handleDiscountError('shipping');
            return;
        }

        if ( this.type == 'main-cart') {
            location.reload();
        }

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
        }));
    }

    // Remove discount code
    async removeDiscount(event) {
        const pill = event.target.closest('.cart-discount-pill');
        if (!(pill instanceof HTMLLIElement)) return;

        const code = pill.dataset.discountCode;
        if (!code) return;

        const existingDiscounts = this.#existingDiscounts().filter((d) => d !== code);

        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                discount: existingDiscounts.join(','),
            }),
        });

        if ( this.type == 'main-cart') {
            location.reload();
        }

        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true
        }));
    }

    // Handle error
    #handleDiscountError(type) {
        console.log('passe handle error', type);

        const target = type === 'discount_code' ? this.errorDiscountCode : this.errorShipping;
        target?.classList.remove('hidden');
    }

    // Check if code already apply
    #existingDiscounts() {
        const discountCodes = [];
        const pills = this.querySelectorAll('.cart-discount-pill');

        for (const pill of pills) {
            if (pill instanceof HTMLLIElement && pill.dataset.discountCode) {
                discountCodes.push(pill.dataset.discountCode);
            }
        }

        return discountCodes;
    }
}

if (customElements.get('w3-cart-discount') === undefined) {
    customElements.define('w3-cart-discount', CartDiscount);
}
